import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=4b7fed3e&scoped=true"
import script from "./registered.vue?vue&type=script&lang=js"
export * from "./registered.vue?vue&type=script&lang=js"
import style0 from "./registered.vue?vue&type=style&index=0&id=4b7fed3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7fed3e",
  null
  
)

export default component.exports